// todo: rearrange some of the top-level flags to make more sense, maybe grouped by section of app impacted
export interface IFeatureFlags {
  // e.g. team or super
  isAnyAdmin?: boolean;
  // e.g. only super
  isSuperAdmin?: boolean;
  r2fInspector?: boolean;
  pitchMsDetails?: boolean;
  healthCheck?: boolean;
  machineDebugger?: boolean;
  impersonation?: boolean;
  videoMiscDetails?: boolean;
  gameDataActions?: boolean;
  controls: {
    superMode?: boolean;
    downloadVideo?: boolean;
    cameraSources?: boolean;
    rapidMode?: boolean;
    switchMachine?: boolean;
    plateViewExtras?: boolean;
  };
  manage: {
    plateDistance?: boolean;
    pitchListType?: boolean;
    cardAccess?: boolean;
  };
  sections: {
    hitterLibrary?: boolean;
    videoLibrary?: boolean;
    analytics?: boolean;
    adminApiKeys?: boolean;
    adminBallTypes?: boolean;
    adminErrorTypes?: boolean;
    adminMachineModels?: boolean;
    adminPortal?: boolean;
    adminServerControls?: boolean;
    adminServerErrors?: boolean;
    adminStaticVideos?: boolean;
    adminTeams?: boolean;
    featureDemo?: boolean;
  };
  adminModels: {
    update?: boolean;
  };
  adminMachines: {
    create?: boolean;
    firmware?: boolean;
    install?: boolean;
    logs?: boolean;
    pitchReport?: boolean;
    refreshLists?: boolean;
    restoreLists?: boolean;
    restartOS?: boolean;
  };
  adminTeams: {
    permissions?: boolean;
    create?: boolean;
    update?: boolean;
    refreshLists?: boolean;
    restoreLists?: boolean;
  };
  adminUsers: {
    delete?: boolean;
    refreshLists?: boolean;
    restoreLists?: boolean;
    viewSessions?: boolean;
  };
  analytics: {
    exportStats?: boolean;
    visualize?: boolean;
  };
}

export const DEFAULT_FEATURE_FLAGS: IFeatureFlags = {
  sections: {},
  manage: {},
  controls: {},
  adminMachines: {},
  analytics: {},
  adminUsers: {},
  gameDataActions: true,
  adminModels: {},
  adminTeams: {},
};

export const BASIC_USER_FEATURE_FLAGS: IFeatureFlags = {
  sections: {
    hitterLibrary: true,
    videoLibrary: true,
    analytics: true,
  },
  manage: {},
  controls: {},
  adminMachines: {},
  analytics: {},
  adminUsers: {},
  gameDataActions: true,
  adminModels: {},
  adminTeams: {},
};

export const RESTRICTED_BASIC_USER_FEATURE_FLAGS: IFeatureFlags = {
  sections: {},
  manage: {},
  controls: {},
  adminMachines: {},
  analytics: {},
  adminUsers: {},
  adminModels: {},
  adminTeams: {},
};

export const TEAM_ADMIN_FEATURE_FLAGS: IFeatureFlags = {
  isAnyAdmin: true,
  sections: {
    adminPortal: true,
    adminApiKeys: true,
    hitterLibrary: true,
    videoLibrary: true,
    analytics: true,
  },
  manage: {},
  controls: {
    switchMachine: true,
  },
  adminMachines: {},
  analytics: {},
  adminUsers: {},
  gameDataActions: true,
  adminModels: {},
  adminTeams: {},
};

// during a game
export const RESTRICTED_TEAM_ADMIN_FEATURE_FLAGS: IFeatureFlags = {
  isAnyAdmin: true,
  sections: {},
  manage: {},
  controls: {
    switchMachine: true,
  },
  adminMachines: {},
  analytics: {},
  adminUsers: {},
  adminModels: {},
  adminTeams: {},
};

export const SUPER_ADMIN_FEATURE_FLAGS: IFeatureFlags = {
  isAnyAdmin: true,
  isSuperAdmin: true,
  r2fInspector: true,
  pitchMsDetails: true,
  healthCheck: true,
  machineDebugger: true,
  impersonation: true,
  videoMiscDetails: true,
  manage: {
    plateDistance: true,
    pitchListType: true,
    cardAccess: true,
  },
  sections: {
    adminBallTypes: true,
    adminErrorTypes: true,
    adminMachineModels: true,
    adminPortal: true,
    adminServerControls: true,
    adminServerErrors: true,
    adminStaticVideos: true,
    adminTeams: true,
    featureDemo: true,
    adminApiKeys: true,
    hitterLibrary: true,
    videoLibrary: true,
    analytics: true,
  },
  controls: {
    superMode: true,
    downloadVideo: true,
    cameraSources: true,
    rapidMode: true,
    switchMachine: true,
    plateViewExtras: true,
  },
  adminMachines: {
    create: true,
    firmware: true,
    install: true,
    logs: true,
    pitchReport: true,
    refreshLists: true,
    restartOS: true,
    restoreLists: true,
  },
  analytics: {
    exportStats: true,
    visualize: true,
  },
  adminUsers: {
    delete: true,
    refreshLists: true,
    restoreLists: true,
    viewSessions: true,
  },
  gameDataActions: true,
  adminModels: {
    update: true,
  },
  adminTeams: {
    create: true,
    permissions: true,
    update: true,
    refreshLists: true,
    restoreLists: true,
  },
};
